// @flow
import styled from "styled-components";

export const Outer = styled.div`
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 900px;
    margin-top: 25px;
    background-color: #fff;

    @media only screen and (min-width: 768px) {
    }
`;

export const MapOuter = styled.div`
    width: 100%;
    margin-top: 25px;
`;
export const Map = styled.div`
    border-top: 1px solid #dddfe2;
    border-bottom: 1px solid #dddfe2;
    width: 100%;
    height: 100vh;
`;

export const SpinnerContainer = styled.div`
    text-align: center;
    margin-top: 25px;
`;

export const Stops = styled.div`
    padding: 16px;
`;

export const Stop = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
`;

export const StopDate = styled.div`
    display: inline-block;
    padding: 8px 0;
    padding: 4px 8px 4px 0;
    width: 180px;
`;
export const Location = styled.div`
    display: inline;
    padding: 4px 8px 4px 0;
`;



// WEBPACK FOOTER //
// ./src/map/styled.js